import { Routes } from '@angular/router';

export const GESTION_FINANCIERA: Routes = [
  {
    path: 'listar',
    loadComponent: () =>
      import('./listar/gestion-financiera-listar.component')
        .then(m => m.GestionFinancieraListarComponent)
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./detalle/gestion-financiera-detalle.component')
        .then(m => m.GestionFinancieraDetalleComponent)
  },
  {
    path: 'asignar-CECO/:id',
    loadComponent: () =>
      import('./asignar-ceco/asignar-ceco.component')
        .then(m => m.AsignarCECOComponent)
  },
  {
    path: 'detalle-CECO/:id',
    loadComponent: () =>
      import('./detalle-ceco/detalle-ceco.component')
        .then(m => m.DetalleCECOComponent)
  },

];
